// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Register the Web Push service worker (booking notifications). Guarded so
// unsupported browsers no-op; the push-subscription controller handles opt-in.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker").catch(() => {})
}

// beforeinstallprompt can fire before Stimulus boots, so stash it here (entry
// point runs early) and re-dispatch. The pwa-install controller reads the stash
// on connect and also listens for the re-dispatch.
// ponytail: single global for one app-wide install banner.
// Only capture on mobile (coarse pointer) — the banner is mobile-only, so on
// desktop we leave the browser's native install affordance (mini-infobar /
// omnibox icon) untouched instead of suppressing it for nothing.
window.addEventListener("beforeinstallprompt", (event) => {
  if (!matchMedia("(pointer: coarse)").matches) return
  event.preventDefault()
  window.__deferredInstallPrompt = event
  window.dispatchEvent(new CustomEvent("pwa:installable"))
})
